import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EditIcon } from "assets/images/common/svgs";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useCupOfGratitude from "../useHooks";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import useStore from "hooks/useStore";
import { sitePermissions } from "utils/helpers/enums/permissions.enum";

const CupGratitudeListing: React.FC = () => {
  const { hasPermission } = useStore();
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const { getCupOfGratitude } = useCupOfGratitude();
  useEffect(() => {
    const fetchData = async () => {
      await getCupOfGratitude(setData);
    };
    fetchData();
  }, []);

  return (
    <div className="pb-6">
      <h1 className="text-2xl sm:text-[32px] text-primaryText font-bold">
        Cup of Gratitude
      </h1>

      <div className="flex justify-between items-center gap-5 my-6">
        {hasPermission(sitePermissions.cupOfGratitudeCreate) && (
          <button
            onClick={() => navigate(siteRoutes.cupOfGratitudeCreate)}
            className="px-4 py-2 text-sm bg-goldenOrangeBg text-white rounded-lg font-semibold"
          >
            Create Cup of Gratitude
          </button>
        )}
      </div>

      <div className="bg-white p-6 rounded-lg">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.map((item: any, index: number) => (
            <div
              key={index + 1}
              className="bg-dividerLightBg relative border border-stokeLight rounded-[30px] p-6 flex flex-col items-center justify-center gap-2 text-center h-[322px]"
            >
              <span>
                {hasPermission(sitePermissions.cupOfGratitudeUpdate) ? (
                  <span
                    onClick={() => {
                      navigate(
                        `${siteRoutes.cupOfGratitudeEdit}?id=${item.id}`
                      );
                    }}
                    className="bg-goldenOrangeBg cursor-pointer p-2 rounded-md absolute top-5 right-5"
                  >
                    <EditIcon />
                  </span>
                ) : (
                  <span className="bg-goldenOrangeBg cursor-not-allowed p-2 rounded-md absolute top-5 right-5">
                    <EditIcon />
                  </span>
                )}
              </span>

              <div className="relative">
                <img
                  src={
                    item?.image
                      ? concatPathWithBackendUrl(item?.image?.fileDownloadUri)
                      : ""
                  }
                  alt={item?.name}
                  className="w-[157px] h-[177px]"
                />
              </div>

              <h3 className="text-primaryText text-2xl font-bold">
                {item?.name}
              </h3>
              <span className="">{item?.price}$</span>
              {/* <p className="text-base">Cost 1$</p> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CupGratitudeListing;
